import { EquipmentNameTooltipProps } from '../../types';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatTextPassage } from '@blocks-react/components/TextPassage';

export const EquipmentNameTooltip = ({
  toolTipContent,
  children
}: Readonly<EquipmentNameTooltipProps>) => {
  return (
    <CatTooltip position="auto">
      {children}
      <CatTextPassage>{toolTipContent}</CatTextPassage>
    </CatTooltip>
  );
};
